import BenefitsSection from '@/v2/components/sections/common/benefits-section'
import FaqSection from '@/v2/components/sections/common/faq-section'
import ForWhoSection from '@/v2/components/sections/common/for-who-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  benefitsSectionContent,
  boxSizesAndLimitsSectionContent,
  faqSectionContent,
  forWhoSectionContent,
  helperSectionContent,
  heroSectionContent,
  promotionalBannerSectionContent,
  serviceTipsSectionSectionContent,
  whoCanBenefitSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/moving-box-shipping-page'

interface MovingBoxShippingPageProps {}

const MovingBoxShippingPage: React.FC<MovingBoxShippingPageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
        w-[350px] h-[197px] 
        lg-mn:w-[460px] lg-mn:h-[259px] 
        xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[269px] md-mn:w-[240px] xl-min:h-[50px] w-[278px] h-[44px]'
      />
      <WhyWeSection isBgDark {...whyWeSectionContent} />
      <ServiceTipsSection {...serviceTipsSectionSectionContent} />
      <HelperSection isBgDark {...helperSectionContent} buttonClassName={`xl-min:!w-[269px] w-[240px]`} />
      <ForWhoSection
        {...boxSizesAndLimitsSectionContent}
        imgClassName='w-[191px] h-[171px]'
        className='[&_ul]:list-none xl-min:[&_article]:!flex-row [&_article]:!flex-col xl-min:[&_article]:text-left [&_article]:text-center md-mn:[&_article]:px-5 [&>div>div:last-child]:md-mn:grid-cols-3'
      />
      <ForWhoSection isBgDark {...forWhoSectionContent} />
      <WhyWeSection
        {...whoCanBenefitSectionContent}
        className='[&_article]:border-none [&_article]:bg-transparent'
        sectionTitleClassName='w-full [&_h2]:p-0 [&_h2]:text-pretty'
      />
      <BenefitsSection
        isBgDark
        {...benefitsSectionContent}
        sectionTitleClassName='w-full [&_h2]:p-0 [&_h2]:text-pretty'
        className='md-mn:[&_article>div:first-of-type]:self-start'
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        className='xl-min:[&_button]:!w-[229.08px] md-mn:[&_button]:w-[254px] [&_button]:w-[230px]'
        imgClassName='xl-min:!w-[526px] xl-min:!h-[270px] lg-mn:w-[390px] lg-mn:h-[200px] w-[324px] h-[166px]'
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default MovingBoxShippingPage
